import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-[#1a1c1b]">
      <Header />
      
      <main className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-5 md:px-10">
          <h1 className="text-3xl md:text-4xl font-black text-[#d9fb06] uppercase mb-8">
            Terms of Service
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-6 text-[#888680]">
            <p className="text-sm">Last updated: February 2025</p>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">1. Service Description</h2>
              <p>
                Social Dispute Co provides dispute documentation preparation and submission services 
                for social media account enforcement issues. We prepare formal notices, compile evidence, 
                and prepare documentation for submission through official platform appeal channels on behalf of clients.
              </p>
              <p className="mt-4 font-semibold text-[#dfddd6]">
                Social Dispute Co is NOT a law firm and does NOT provide legal advice.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">2. No Guarantee of Results</h2>
              <p>
                We do not and cannot guarantee any specific outcome. Platform decisions regarding 
                account reinstatement are made solely by the respective platforms and are outside 
                our control. Results vary based on:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>The specific platform's policies and procedures</li>
                <li>Your account history and standing</li>
                <li>The nature of the alleged violation</li>
                <li>Evidence provided</li>
                <li>Platform discretion</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">3. Client Responsibilities</h2>
              <p>By using our services, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate and truthful information</li>
                <li>Respond promptly to requests for additional information</li>
                <li>Not misrepresent the nature of your account or dispute</li>
                <li>Understand that results are not guaranteed</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">4. Payment Terms</h2>
              <p>
                Payment is due upon acceptance of service. Payment covers document preparation and 
                submission services only, not outcomes. Accepted payment methods include PayPal, 
                Venmo, Zelle, and ACH transfer.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">5. Nature of Services</h2>
              <p>
                Social Dispute Co. is not a law firm and does not provide legal advice. 
                We provide documentation preparation and submission guidance only.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">6. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Social Dispute Co shall not be liable for 
                any indirect, incidental, special, consequential, or punitive damages, including 
                but not limited to loss of profits, data, or other intangible losses resulting from 
                your use of our services.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">7. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Social Dispute Co from any claims, damages, 
                or expenses arising from your use of our services, your violation of these terms, 
                or your violation of any rights of another.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">8. Modifications</h2>
              <p>
                We reserve the right to modify these terms at any time. Continued use of our services 
                after changes constitutes acceptance of the modified terms.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">9. Governing Law</h2>
              <p>
                These terms shall be governed by and construed in accordance with the laws of the 
                State of Hawaii, without regard to its conflict of law provisions.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">10. Contact</h2>
              <p>For questions about these terms, contact us at:</p>
              <p className="text-[#dfddd6]">
                Email: intake@socialdisputeco.com<br />
                Phone: 808-301-2134
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
